// extracted by mini-css-extract-plugin
export default {"report":"survey_report__yppMV","titleHeader":"survey_titleHeader__NcDBc","title":"survey_title__LK9kT"};